import {View, Platform, StyleSheet} from 'react-native';
import {useWebBodyBackground} from '@/hooks/useWebBodyBackground';

interface Props {
    children: React.ReactNode;
}

export function WebMaxWidthContainer({children}: Props) {
    useWebBodyBackground();

    // On mobile, just return children without wrapper
    if (Platform.OS !== 'web') {
        return <>{children}</>;
    }

    // On web, wrap with outer (full width) and inner (max-width) containers
    return (
        <View style={styles.outerContainer}>
            <View style={styles.innerContainer}>
                {children}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    outerContainer: {
        flex: 1,
        width: '100%',
    },
    innerContainer: {
        flex: 1,
        width: '100%',
        maxWidth: 1440,
        alignSelf: 'center',
    },
});
